import { getPercentageGetter } from '../../utils/getPercentageGetter';
import { getCompactNumberFormat } from './getCompactNumberFormat';

export const getScoreDisplayText = (
  score: number,
  shouldShowScorePercentage: false | { percentOf: number },
): string => {
  if (shouldShowScorePercentage) {
    const getPercentage = getPercentageGetter(
      shouldShowScorePercentage.percentOf,
    );
    return getPercentage(score).toFixed(0) + '%';
  } else {
    return getCompactNumberFormat(score);
  }
};
